<template>
  <div class="container">
    <div class="news">
      <div class="news-body">
        <div class="news-body-view">
          <div class="news-body-centent">
            <!-- 播聘新闻 -->
            <ul class="news-body-item-views">
              <li class="news-body-item-v" v-for="(s,i) in list" :key="i">
                <div class="news-body-item-content">
                  <div class="news-body-item-v-bg" :style="`background-image: url(${s.img});`"></div>
                  <div class="news-body-item-v-title">{{s.title}}</div>
                  <div class="news-body-item-v-sub">
                    <div class="news-body-item-v-sub-from">1来源：{{s.froms}}</div>
                    <div>时间：{{s.date}}</div>
                  </div>
                  <div class="news-body-item-v-content">{{s.content}}</div>
                  <div class="news-body-item-v-more" @click="navgoTo(s)">阅读全文></div>
                </div>
              </li>
            </ul>
              </div>
              </div>
   </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "recruitment-skills",
  data() {
    return {
             //播聘新闻
      list: [
        {
          title: "求职及面试的一些小技巧",
          froms: "播聘",
          
          date: "2019年9月24日 | 求职技巧",
          img: ".../../../static/job-hunting-skills.jpg",
          content:
            "对相当一部分的部门需求者而言，如果求职者不是绝对的让部门需求者满意，那么他们都会有一个想法：在看几个人吧，看后面有没有更合适的；这样不知不觉的最早面试的那一批求职者就被遗忘了，其结果就是做炮灰了，所以面试之前最好先查一查所面试的职位到底什么时候公开放出来的，我个人推荐“启信宝”APP，通过这个APP可以查出来职位首次发布的时间及渠道。 此外，也有必要查一下该职位的历史发布情况，比如一个公司本来就不大，有些岗位理论上来讲公司只会设一个，比如行政经理，通过查询如果你发现最近一年每隔几个月就发布一次，那就得多留个心眼，要么频繁的换人，要么招一段时间不招了然后过一阵子又接着招。",
          path: "/job-hunting-skills-to"
        },
      ],
    }
  },
     methods: {
          navgoTo(s) {
      this.$nav({ path: s.path }, this);
    }
     }
};
</script>

<style scoped="scoped">
@import url("./job-hunting-skills.css");
</style>


// WEBPACK FOOTER //
// src/pages/job-hunting-skills/job-hunting-skills.vue